import { render, staticRenderFns } from "./jobCopyWindow.vue?vue&type=template&id=a53fa746&"
import script from "./jobCopyWindow.vue?vue&type=script&lang=js&"
export * from "./jobCopyWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a53fa746')) {
      api.createRecord('a53fa746', component.options)
    } else {
      api.reload('a53fa746', component.options)
    }
    module.hot.accept("./jobCopyWindow.vue?vue&type=template&id=a53fa746&", function () {
      api.rerender('a53fa746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/jobCopyWindow.vue"
export default component.exports